/* Generated from Java with JSweet 2.3.7 - http://www.jsweet.org */
import { AaiOperationTrait } from '../../models/AaiOperationTrait';
import { AaiTag } from '../../models/AaiTag';
import { Node } from '../../../core/models/Node';

/**
 * Constructor.
 * @param {Node} parent
 * @param {string} opType
 * @class
 * @extends AaiOperationTrait
 * @author Jakub Senko<jsenko@redhat.com>
 */
export class Aai20OperationTrait extends AaiOperationTrait {
    public constructor(parent? : any, opType? : any) {
        if(((parent != null && parent instanceof <any>Node) || parent === null) && ((typeof opType === 'string') || opType === null)) {
            let __args = arguments;
            super(parent, opType);
        } else if(((typeof parent === 'string') || parent === null) && opType === undefined) {
            let __args = arguments;
            let opType : any = __args[0];
            super(opType);
        } else if(((parent != null && parent instanceof <any>Node) || parent === null) && opType === undefined) {
            let __args = arguments;
            super(parent);
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.asyncapi.models.AaiOperationBase#createTag()
     * @return {AaiTag}
     */
    public createTag() : AaiTag {
        return new Aai20Tag(this);
    }

    /**
     * @see io.apicurio.datamodels.core.models.common.Operation#createExternalDocumentation()
     * @return {Aai20ExternalDocumentation}
     */
    public createExternalDocumentation() : Aai20ExternalDocumentation {
        return new Aai20ExternalDocumentation(this);
    }
}
Aai20OperationTrait["__class"] = "io.apicurio.datamodels.asyncapi.v2.models.Aai20OperationTrait";
Aai20OperationTrait["__interfaces"] = ["io.apicurio.datamodels.core.models.IVisitable","io.apicurio.datamodels.core.models.IReferenceNode","io.apicurio.datamodels.asyncapi.models.IAaiTrait","io.apicurio.datamodels.core.models.common.IExternalDocumentationParent"];





import { Aai20ExternalDocumentation } from './Aai20ExternalDocumentation';


import { Aai20Tag } from './Aai20Tag';

